import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { lastValueFrom, take } from 'rxjs';
import { LessorList } from 'src/app/api/models/lessor.model';
import { LessorService } from 'src/app/api/services/lessor.service';
import { AppResource } from 'src/app/app.resource';
import { TypeBailleur } from 'src/app/core/models/form-state.model';
import { Stepper } from 'src/app/core/models/stepper.model';
import * as fromHousing from 'src/app/core/state/housing';
import * as fromInfo from 'src/app/core/state/info';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import {
  CANCELLATION_PATH,
  COLOC_PATH,
  PAYMENT_PATH,
  ROOT_PATH
} from 'src/app/shared/constants/route.constants';
import { HeaderVM } from 'src/app/shared/models/components/headerVm';
import { PopUpInfoVM } from 'src/app/shared/models/components/popupinfoVm';
import { QuestionVM } from 'src/app/shared/models/components/questionVm';
import { LessorCertificateEnum } from 'src/app/shared/models/enum/lessorcertificate.enum';
import * as fromAdresse from '../../../core/state/address';
import { AddressState } from '../../../core/state/address';
import { State } from '../../../core/state/core.state';
import * as fromPath from '../../../core/state/path';
import * as fromService from '../../../core/state/service';
interface Lessor {
  text: string;
  value: number | string;
  email: string | null;
  lessorType: number | null;
}

@Component({
  selector: 'app-lessor-certificate',
  templateUrl: './lessor-certificate.component.html',
  styleUrls: ['./lessor-certificate.component.scss']
})
export class LessorCertificateComponent extends BaseComponent implements OnInit {
  headerStep!: HeaderVM;
  override question!: QuestionVM;
  // numberLocalInfo!: string;
  clientAccountInfo!: PopUpInfoVM;

  // State (Connaître la prochaine étape: Résiliation ou paiment)
  displayModal: boolean = false;
  msgShow: boolean = false;

  //Step
  step1Social: boolean = false;
  step2Social: boolean = false;

  //Form
  social: boolean = false;
  socialForm!: FormGroup;
  private: boolean = false;
  privateForm!: FormGroup;

  alreadyOccupied: boolean = false;
  notAlreadyOccupied: boolean = false;

  skip!: string;

  filterValue = '';
  selectedLessor!: Lessor | undefined;
  lessorCertificatEnum = LessorCertificateEnum;

  lessorNotFind: boolean = true;
  otherLessor: boolean = false;
  lessorsList: LessorList = [];
  private productCode!: string;
  private zipCode!: string;

  placeholderRefClient!: string;
  errorRefClient!: string;

  placeholderCC!: string;
  errorCC!: string;

  emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;

  get email() {
    return this.privateForm.get('email');
  }

  get lessor() {
    return this.socialForm.get('lessor');
  }

  get otherName() {
    return this.socialForm.get('otherName');
  }

  get otherEmail() {
    return this.socialForm.get('otherEmail');
  }

  get principalLocal() {
    return this.socialForm.get('principalLocal');
  }

  get clientAccount() {
    return this.socialForm.get('clientAccount');
  }

  get lessorList() {
    return [
      ...(this.lessorsList
        ? this.lessorsList
            .filter(b => this.emailRegex.test(b.email))
            .map(b => ({
              text: b.name,
              value: b.id,
              email: b.email,
              lessorType: b.lessorType
            }))
        : []),
      { text: 'Autre', value: 'OTR', email: null, lessorType: null }
    ];
  }

  lessorCertificateInfo: PopUpInfoVM;

  lessorType: number = 0;
  isBailleurSocial: boolean = false;

  constructor(
    store: Store<State>,
    resources: AppResource,
    private router: Router,
    private lessorService: LessorService
  ) {
    super(store, resources);

    this.resource = resources['resource'];
    this.headerStep = new HeaderVM(
      this.resource.header.stepContract,
      3,
      this.resource.header.subStepLessorCertificate,
      4
    );

    this.question = new QuestionVM(this.resource.question.associatedService2);

    this.clientAccountInfo = new PopUpInfoVM([this.resource.infobulle.otherCC]);

    this.skip = this.resource.lessorcertificate.skipStep;
    // Initialize question
    this.lessorCertificateInfo = new PopUpInfoVM([
      this.resource.infobulle.lessorInfo,
      this.resource.infobulle.lessorInfo2
    ]);
  }

  override async ngOnInit() {
    super.ngOnInit();

    this.initForm();
    this.productCode = await lastValueFrom(
      this.store.select(fromPath.selectPathType).pipe(take(1))
    );

    const lessor = await lastValueFrom(this.store.select(fromService.selectService).pipe(take(1)));

    this.isBailleurSocial = !!lessor.saisieChoixServices.EnvoiAttestationBailleur;

    if (
      this.isBailleurSocial &&
      lessor.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.TypeBailleur &&
      lessor.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.TypeBailleur < 5
    ) {
      this.updateAndRedirect();
    }

    await lastValueFrom(this.store.select(fromAdresse.selectAddress).pipe(take(1))).then(
      (address: AddressState) => {
        if (address.addresseSelection?.AdresseEsh.CodePostal)
          this.zipCode = address.addresseSelection?.AdresseEsh.CodePostal;
        else if (address.addresseManuelle.CodePostal)
          this.zipCode = address.addresseManuelle.CodePostal;
        else if (address.adresseEsh?.CodePostal) this.zipCode = address.adresseEsh?.CodePostal;
      }
    );

    this.lessorService.GetLessorsListByZipCode(this.zipCode).subscribe((response: LessorList) => {
      this.lessorsList = response;
      this.loadStateData();
    });

    this.lessor?.valueChanges.subscribe((value: any) => {
      if (value?.value === 'OTR') {
        this.otherName?.setValidators(Validators.required);
        this.otherEmail?.addValidators(Validators.required);
        this.otherEmail?.addValidators(
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
        );
        this.principalLocal?.clearValidators();
        this.clientAccount?.clearValidators();
        this.otherLessor = true;
        this.step1Social = false;
        this.step2Social = false;
      } else {
        this.otherName?.clearValidators();
        this.otherEmail?.clearValidators();
        this.principalLocal?.setValidators(Validators.required);
        this.clientAccount?.setValidators(Validators.required);
        this.otherLessor = false;
        this.lessorNotFind = true;
      }

      this.otherName?.updateValueAndValidity();
      this.otherEmail?.updateValueAndValidity();
      this.principalLocal?.updateValueAndValidity();
      this.clientAccount?.updateValueAndValidity();
    });

    this.otherName?.valueChanges.subscribe((value: string) => {
      let regex = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
      let emailValid = regex.test(this.otherEmail?.value);
      if (emailValid && value != undefined && value != null && value != '')
        this.updateInfoLessor(value);
    });

    this.otherEmail?.valueChanges.subscribe((value: any) => {
      let regex = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
      let emailValid = regex.test(value);
      if (emailValid && (this.otherName?.value != undefined || null || ''))
        this.updateInfoLessor(value);
    });
  }

  private initForm() {
    this.socialForm = new FormGroup(
      {
        lessor: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        otherName: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        otherEmail: new FormControl<string | null>(null, {
          validators: [
            Validators.required,
            Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
          ],
          nonNullable: true
        }),
        principalLocal: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        }),
        clientAccount: new FormControl<string | null>(null, {
          validators: [Validators.required],
          nonNullable: true
        })
      },
      {
        updateOn: 'change'
      }
    );

    this.privateForm = new FormGroup({
      email: new FormControl<string | null>('', {
        validators: [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
        ],
        nonNullable: true,
        updateOn: 'change'
      })
    });
  }

  private async loadStateData() {
    let service = await lastValueFrom(this.store.select(fromService.selectService).pipe(take(1)));
    this.lessorType =
      service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.TypeBailleur ?? 0;

    this.selectedLessor = this.lessorList.find(
      (obj: Lessor) =>
        obj.text ===
        service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur
    );

    if (service.saisieChoixServices.EnvoiAttestationBailleur?.TypeBailleur == TypeBailleur.Social) {
      this.social = true;

      this.lessor!.setValue(
        this.lessorList.find(
          (obj: Lessor) =>
            obj.text ===
            (service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur ??
              'Autre')
        )
      );

      if (
        this.selectedLessor == undefined &&
        this.isBailleurSocial &&
        service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur == ''
      ) {
        if (
          service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur === ''
        ) {
          this.lessor?.setValue(this.lessorList.find(obj => obj.value === 'OTR'));
        }

        if (this.selectedLessor == undefined) {
          this.lessor?.clearValidators();
          this.lessor?.updateValueAndValidity();

          this.otherLessor = true;
          this.otherName?.setValue(
            service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur
          );

          this.otherEmail?.setValue(
            service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.Email
          );
        }

        this.updateInfoLessor(
          service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur
        );
      } else if (this.selectedLessor != undefined) this.updateInfoLessor(this.selectedLessor.text);

      if (
        this.lessor?.value != undefined &&
        service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur != null &&
        service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial?.NomBailleur != ''
      ) {
        this.step1Social = true;
        this.step2Social = true;
      }

      this.principalLocal?.setValue(
        service.saisieChoixServices.EnvoiAttestationBailleur.BailleurSocial?.Reference1
      );

      this.clientAccount?.setValue(
        service.saisieChoixServices.EnvoiAttestationBailleur.BailleurSocial?.Reference2
      );
      if (service.saisieChoixServices.EnvoiAttestationBailleur.BailleurSocial != undefined) {
        if (service.saisieChoixServices.EnvoiAttestationBailleur.BailleurSocial.LogementOccupe)
          this.alreadyOccupied = true;
        if (!service.saisieChoixServices.EnvoiAttestationBailleur.BailleurSocial.LogementOccupe)
          this.notAlreadyOccupied = true;
      }
    } else if (
      service.saisieChoixServices.EnvoiAttestationBailleur?.TypeBailleur == TypeBailleur.Prive
    ) {
      this.private = true;

      this.email?.setValue(
        service.saisieChoixServices.EnvoiAttestationBailleur.BailleurPrive?.Email
      );
    } else {
      //si bailleur de type 1,2,3,4 pas d'écran => résiliation ou autre.
      //si bailleur de type 5 alors écran avec step social
      //si autre ou privé alors écran avec email
      if (this.selectedLessor != undefined && this.selectedLessor != null) {
        if (this.selectedLessor.lessorType != null && this.selectedLessor.lessorType < 5) {
          this.store.dispatch(
            fromService.patchService({
              payload: {
                EnvoiAttestationBailleur: {
                  TypeBailleur: TypeBailleur.Social,
                  BailleurSocial: {
                    NomBailleur: this.selectedLessor.text,
                    Email: this.selectedLessor.email,
                    LogementOccupe: null,
                    Reference1: this.principalLocal?.value,
                    Reference2: this.clientAccount?.value,
                    TypeBailleur: this.selectedLessor?.lessorType ?? null
                  },
                  BailleurPrive: undefined,
                  isValid: true
                }
              }
            })
          );
          this.updateAndRedirect();
        } else if (this.selectedLessor?.lessorType === 5) {
          this.social = true;

          this.lessor!.setValue(
            this.lessorList.find(
              (obj: Lessor) =>
                obj.text ===
                (service.saisieChoixServices.EnvoiAttestationBailleur?.BailleurSocial
                  ?.NomBailleur ?? 'Autre')
            )
          );

          this.updateInfoLessor(this.selectedLessor.text);

          this.step1Social = true;
          this.step2Social = true;
        }
      } else this.private = true;
    }
  }

  nextStepType(value: string) {
    switch (value) {
      case TypeBailleur.Social:
        this.social = true;
        this.private = false;

        this.store.dispatch(
          fromService.patchService({
            payload: {
              EnvoiAttestationBailleur: {
                TypeBailleur: TypeBailleur.Social,
                isValid: false
              }
            }
          })
        );

        break;
      case TypeBailleur.Prive:
        this.private = true;
        this.social = false;

        this.store.dispatch(
          fromService.patchService({
            payload: {
              EnvoiAttestationBailleur: {
                TypeBailleur: TypeBailleur.Prive,
                isValid: false
              }
            }
          })
        );

        break;
      default:
        break;
    }
  }

  nextStepSocial(value: string) {
    switch (value) {
      case LessorCertificateEnum.Yes:
        this.alreadyOccupied = true;
        this.notAlreadyOccupied = false;
        this.step2Social = true;
        break;
      case LessorCertificateEnum.No:
        this.notAlreadyOccupied = true;
        this.alreadyOccupied = false;
        this.step2Social = false;
        if (!this.msgShow) this.displayModal = true;
        break;
      default:
        break;
    }
  }

  nextStep(typeBailleur: string) {
    switch (typeBailleur) {
      case LessorCertificateEnum.Social:
        let lessorName =
          this.lessor?.value?.value === 'OTR' ? this.otherName?.value : this.lessor?.value?.text;

        let lessorEmail =
          this.lessor?.value?.value === 'OTR' ? this.otherEmail?.value : this.lessor?.value?.email;

        this.store.dispatch(
          fromService.patchService({
            payload: {
              EnvoiAttestationBailleur: {
                TypeBailleur: TypeBailleur.Social,
                BailleurSocial: {
                  NomBailleur: lessorName,
                  Email: lessorEmail,
                  LogementOccupe: this.selectedLessor?.value === 'OTR' ? null : this.step2Social,
                  Reference1: this.principalLocal?.value,
                  Reference2: this.clientAccount?.value,
                  TypeBailleur: this.selectedLessor?.lessorType ?? null
                },
                BailleurPrive: undefined,
                isValid: true
              }
            }
          })
        );
        break;
      case LessorCertificateEnum.Private:
        this.store.dispatch(
          fromService.patchService({
            payload: {
              EnvoiAttestationBailleur: {
                TypeBailleur: TypeBailleur.Prive,
                BailleurSocial: undefined,
                BailleurPrive: {
                  NomBailleur: null,
                  Email: this.email?.value
                },
                isValid: true
              }
            }
          })
        );
        break;
    }

    this.updateStepper(false);

    this.updateAndRedirect();
  }

  skipStep() {
    let typeBailleur = undefined;
    if (this.social) typeBailleur = TypeBailleur.Social;
    else if (this.private) typeBailleur = TypeBailleur.Prive;

    if (typeBailleur != undefined) {
      if (typeBailleur == TypeBailleur.Social) {
        let lessorName = this.selectedLessor?.value === 'OTR' ? this.otherName?.value : '';

        let lessorEmail = this.selectedLessor?.value === 'OTR' ? this.otherEmail?.value : '';

        this.store.dispatch(
          fromService.patchService({
            payload: {
              EnvAttB: false,
              EnvoiAttestationBailleur: {
                TypeBailleur: typeBailleur,
                BailleurSocial: {
                  NomBailleur: lessorName,
                  Email: lessorEmail,
                  LogementOccupe: this.selectedLessor?.value === 'OTR' ? null : this.step2Social,
                  Reference1: this.principalLocal?.value,
                  Reference2: this.clientAccount?.value,
                  TypeBailleur: this.selectedLessor?.lessorType ?? null
                },
                BailleurPrive: undefined,
                isValid: false
              }
            }
          })
        );
      } else if (typeBailleur == TypeBailleur.Prive) {
        this.store.dispatch(
          fromService.patchService({
            payload: {
              EnvAttB: false,
              EnvoiAttestationBailleur: {
                TypeBailleur: typeBailleur,
                BailleurSocial: undefined,
                BailleurPrive: {
                  NomBailleur: null,
                  Email: this.email?.value
                },
                isValid: false
              }
            }
          })
        );
      }
    } else {
      this.store.dispatch(
        fromService.patchService({
          payload: {
            EnvAttB: false,
            EnvoiAttestationBailleur: {
              TypeBailleur: undefined,
              BailleurSocial: undefined,
              BailleurPrive: undefined,
              isValid: false
            }
          }
        })
      );
    }
    this.updateStepper(true);

    this.updateAndRedirect();
  }

  async updateAndRedirect() {
    // We redirect to payment page or option page
    const housing = await lastValueFrom(this.store.select(fromHousing.selectHousing).pipe(take(1)));

    const services = await lastValueFrom(
      this.store.select(fromService.selectService).pipe(take(1))
    );

    if (!services.saisieChoixServices.ResAncAss)
      if (
        housing.SaisieHabitation?.NombreColocataires &&
        housing.SaisieHabitation?.NombreColocataires > 0
      ) {
        // we redirect to colocataire page
        this.router.navigate([`${ROOT_PATH}${COLOC_PATH}`]);
      } else {
        this.router.navigate([`${ROOT_PATH}${PAYMENT_PATH}`]);
      }
    else this.router.navigate([`${ROOT_PATH}${CANCELLATION_PATH}`]);
  }

  async updateStepper(skip: boolean) {
    let service = await lastValueFrom(this.store.select(fromService.selectService).pipe(take(1)));
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    let tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.contract.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.contract
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.lessorcertificate
    );

    if (subtitleS) {
      if (!skip) {
        subtitleS.isValid = true;
        subtitleS.isActive = true;
      } else {
        subtitleS.isValid = false;
        subtitleS.isActive = false;
        subtitleS.isVisible = false;
      }
    }

    if (service.saisieChoixServices.ResAncAss) {
      let subtitleNS = title?.subtitles.find(
        (x: { url: string }) => x.url == this.resource.stepper.cancellation
      );

      if (subtitleNS) {
        subtitleNS.isActive = true;
      }
    } else {
      let titleN = tmpStepper.contract.titles.find(
        (x: { libelle: string }) => x.libelle == this.resource.stepper.sampling
      );

      if (titleN) titleN.isActive = true;

      let subtitleNS = titleN?.subtitles.find(
        (x: { url: string }) => x.url == this.resource.stepper.payment
      );

      if (subtitleNS) {
        subtitleNS.isActive = true;
      }
    }

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  confirmModal() {
    this.displayModal = false;
    this.msgShow = true;
    this.skip = this.resource.nextstep.skip;
  }

  onChangeLessor(selectedValue: any) {
    if (selectedValue.value.value != 'OTR') {
      this.step1Social = true;

      this.updateInfoLessor(selectedValue.value.text);
    } else this.step1Social = false;
  }

  updateInfoLessor(lessor: string) {
    switch (lessor) {
      case 'Elogie Siemp':
        this.placeholderRefClient = this.resource.lessorcertificate.elogieSiempRC;
        this.errorRefClient = this.resource.error.elogieSiempRC;
        this.placeholderCC = this.resource.lessorcertificate.elogieSiempCC;
        this.errorCC = this.resource.error.elogieSiempCC;

        this.clientAccountInfo.texts[0] = this.resource.infobulle.elogieSiempCC;
        this.clientAccountInfo.imgPath = this.resource.infobulle.elogieSiempCcPath;
        break;
      case 'Paris Habitat':
        this.placeholderRefClient = this.resource.lessorcertificate.parisHabitatRC;
        this.errorRefClient = this.resource.error.parisHabitatRC;
        this.placeholderCC = this.resource.lessorcertificate.parisHabitatCC;
        this.errorCC = this.resource.error.parisHabitatCC;

        break;
      case 'RIVP':
        this.placeholderRefClient = this.resource.lessorcertificate.rivpRC;
        this.errorRefClient = this.resource.error.rivpRC;
        this.placeholderCC = this.resource.lessorcertificate.rivpCC;
        this.errorCC = this.resource.error.rivpCC;

        this.clientAccountInfo.texts[0] = this.resource.infobulle.rivpCC;
        this.clientAccountInfo.imgPath = this.resource.infobulle.rivpCcPath;
        break;
      default:
        this.placeholderRefClient = this.resource.lessorcertificate.otherRC;
        this.errorRefClient = this.resource.error.otherRC;
        this.placeholderCC = this.resource.lessorcertificate.otherCC;
        this.errorCC = this.resource.error.otherCC;

        break;
    }
  }

  updateLessor(lessor: Lessor) {
    if (lessor.value != 'OTR') {
      this.lessor?.setValue(lessor.text);
      this.step1Social = true;
      this.otherLessor = false;

      this.updateInfoLessor(lessor.text);
    } else {
      this.step1Social = false;
      this.otherLessor = true;
    }

    this.selectedLessor = lessor;
  }

  ToLowerCase(event: any) {
    let value = event.target.value;
    event.target.value = value.toLowerCase();
  }

  onNotFoundLessorClick() {
    this.selectedLessor = this.lessorList.find(obj => {
      return obj.value === 'OTR';
    });

    this.lessorNotFind = false;
  }

  setClassActive(value: boolean): string {
    return value ? 'active' : 'inactive';
  }
}
